import React from 'react';
import '../css/Footer.css';

import Link from '../composant/Link';

const Footer = ({data}) => {
    return (
        <footer>
            <div className='logo'>
                <img src={data.logo.data.attributes.url} alt="Logo" />
                <p>{data.titre}</p>
            </div>
            <ul>
                {data.links.map((link) => {
                    if(link.display === true){
                        return (
                            <li key={link.id}>
                                <Link data={link}></Link>
                            </li>
                        );
                    }
                    else{
                        return (<></>);
                    }
                })}
            </ul>
        </footer>
    )
}

export default Footer;